import { LessonAuditSummary } from './contentAudit.types';

export interface ProgramOption {
  label: string;
  value: number;
}

export interface UnitGroup {
  lessons: LessonAuditSummary[];
  unitTitle: string | null;
}

// Group consecutive lessons under their unit heading; summary rows already arrive in unit order.
export const groupByUnit = (lessons: LessonAuditSummary[]): UnitGroup[] => {
  const groups: UnitGroup[] = [];
  lessons.forEach((lesson) => {
    const unitTitle = lesson.unit_title ?? null;
    const last = groups[groups.length - 1];
    if (last && last.unitTitle === unitTitle) {
      last.lessons.push(lesson);
    } else {
      groups.push({ lessons: [lesson], unitTitle });
    }
  });
  return groups;
};
